function generateActionNames(block, actions) {
    const result = {};
    actions.forEach((action) => {
        result[action] = `${block}__${action}`;
    });
    return result;
}

// Page actions
export const SET_AVAILABLE_SEARCH_TABS = 'SET_AVAILABLE_SEARCH_TABS';

// Page documents

export const DOCUMENTS_FETCH_DATA_STORE = 'DOCUMENTS_FETCH_DATA_STORE';
export const DOCUMENTS_FETCH_DATA_STARTED = 'DOCUMENTS_FETCH_DATA_STARTED';
export const DOCUMENTS_FETCH_DATA_LOADED = 'DOCUMENTS_FETCH_DATA_LOADED';
export const DOCUMENTS_CLEAR_DATA_STORE = 'DOCUMENTS_CLEAR_DATA_STORE';
export const DOCUMENTS_SHARE_ITEM_INIT = 'DOCUMENTS_SHARE_ITEM';
export const DOCUMENTS_SHARE_ITEM_CANCEL = 'DOCUMENTS_SHARE_ITEM_CANCEL';
export const DOCUMENTS_SHARE_EMAILS_FETCH_DATA_STORE = 'DOCUMENTS_SHARE_EMAILS_FETCH_DATA_STORE';
export const DOCUMENTS_CLEAR_PURCHASE_MADE = 'DOCUMENTS_CLEAR_PURCHASE_MADE';
export const DOCUMENTS_LINK_LOADING = 'DOCUMENTS_LINK_LOADING';
export const DOCUMENTS_LINK_LOADING_FINISHED = 'DOCUMENTS_LINK_LOADING_FINISHED';

// Page viewDocumnet

export const VIEW_DOCUMENT_FETCH_DATA_STORE = 'VIEW_DOCUMENT_FETCH_DATA_STORE';
export const VIEW_DOCUMENT_FETCH_DATA_STARTED = 'VIEW_DOCUMENT_FETCH_DATA_STARTED';
export const VIEW_DOCUMENT_FETCH_DATA_LOADED = 'VIEW_DOCUMENT_FETCH_DATA_LOADED';

export const DOCUMENTS_LIBRARY_POPUPS = {
    STORE_DATA: 'DOCUMENTS_LIBRARY_POPUPS__STORE_DATA',
    SET_PAGE_TO_RELOAD: 'DOCUMENTS_LIBRARY_POPUPS__SET_PAGE_TO_RELOAD',
    SET_TYPES: 'DOCUMENTS_LIBRARY_POPUPS__SET_TYPES',
    SET_ACTIVE_COMPANY_ID: 'DOCUMENTS_LIBRARY_POPUPS__SET_ACTIVE_COMPANY_ID',
};

export const DOCUMENT_DELETE_POPUP = {
    OPEN: 'DOCUMENT_DELETE_POPUP__OPEN',
    CLOSE: 'DOCUMENT_DELETE_POPUP__CLOSE',
    SET_DATA: 'DOCUMENT_DELETE_POPUP__SET_DATA',
    RESET_DATA: 'DOCUMENT_DELETE_POPUP__RESET_DATA',
};

export const DOCUMENTS_ADD_POPUP = {
    SET_SAVING_REQUESTED: 'DOCUMENTS_ADD_POPUP__SET_SAVING_REQUESTED',
    UNSET_SAVING_REQUESTED: 'DOCUMENTS_ADD_POPUP__UNSET_SAVING_REQUESTED',
    REMOVE_LAST_SET: 'DOCUMENTS_ADD_POPUP__REMOVE_LAST_SET',
    OPEN: 'DOCUMENTS_ADD_POPUP__OPEN',
    CLOSE: 'DOCUMENTS_ADD_POPUP__CLOSE',
    SET_VIEW: 'DOCUMENTS_ADD_POPUP__SET_VIEW',
    SET_ACTIVE_TYPE_ID: 'DOCUMENTS_ADD_POPUP__SET_ACTIVE_TYPE_ID',
    CANCEL_FILE_UPLOAD: 'DOCUMENTS_ADD_POPUP__CANCEL_FILE_UPLOAD',
    UPDATE_DOCUMENT_DATA: 'DOCUMENTS_ADD_POPUP__UPDATE_DOCUMENT_DATA',
    SET_ACTIVE_PROJECT_ID: 'DOCUMENTS_ADD_POPUP__SET_ACTIVE_PROJECT_ID',
    SET_UPLOADING_STARTED: 'DOCUMENTS_ADD_POPUP__SET_UPLOADING_STARTED',
    STORE_UPLOADING_FILES: 'DOCUMENTS_ADD_POPUP__STORE_UPLOADING_FILES',
    SHOW_VALIDATION_ERRORS: 'DOCUMENTS_ADD_POPUP__SHOW_VALIDATION_ERRORS',
    HIDE_VALIDATION_ERRORS: 'DOCUMENTS_ADD_POPUP__HIDE_VALIDATION_ERRORS',
    SET_UPLOADING_FINISHED: 'DOCUMENTS_ADD_POPUP__SET_UPLOADING_FINISHED',
    CLEAR_FILES_UPLOAD: 'DOCUMENTS_ADD_POPUP__CLEAR_FILES_UPLOAD',
    SET_ACTIVE_COMPANY_ID: 'DOCUMENTS_ADD_POPUP__SET_ACTIVE_COMPANY_ID',
    INC_CURRENT_DOCUMENT_INDEX: 'DOCUMENTS_ADD_POPUP__INC_CURRENT_DOCUMENT_INDEX',
    SET_CURRENT_DOCUMENT_INDEX: 'DOCUMENTS_ADD_POPUP__SET_CURRENT_DOCUMENT_INDEX',
};

export const DOCUMENT_EDIT_POPUP = {
    OPEN: 'DOCUMENT_EDIT_POPUP__OPEN',
    CLOSE: 'DOCUMENT_EDIT_POPUP__CLOSE',
    SET_DATA: 'DOCUMENT_EDIT_POPUP__SET_DATA',
    SHOW_VALIDATION_ERRORS: 'DOCUMENT_EDIT_POPUP__SHOW_VALIDATION_ERRORS',
    HIDE_VALIDATION_ERRORS: 'DOCUMENT_EDIT_POPUP__HIDE_VALIDATION_ERRORS',
    UNSET_SAVING_REQUESTED: 'DOCUMENT_EDIT_POPUP__UNSET_SAVING_REQUESTED',
    SET_SAVING_REQUESTED: 'DOCUMENT_EDIT_POPUP__SET_SAVING_REQUESTED',
    STORE_UPLOADING_FILE: 'DOCUMENT_EDIT_POPUP__STORE_UPLOADING_FILE',
    REMOVE_REQUESTED_SAVE_DATA: 'DOCUMENT_EDIT_POPUP__REMOVE_REQUESTED_SAVE_DATA',
    STORE_REQUESTED_SAVE_DATA: 'DOCUMENT_EDIT_POPUP__STORE_REQUESTED_SAVE_DATA',
};

export const PROJECT_EDIT_POPUP = {
    OPEN: 'PROJECT_EDIT_POPUP__OPEN',
    CLOSE: 'PROJECT_EDIT_POPUP__CLOSE',
    SET_DATA: 'PROJECT_EDIT_POPUP__SET_DATA',
};

export const PROJECT_CREATE_POPUP = {
    OPEN: 'PROJECT_CREATE_POPUP__OPEN',
    CLOSE: 'PROJECT_CREATE_POPUP__CLOSE',
    SET_VIEW: 'PROJECT_CREATE_POPUP__SET_VIEW',
    SET_DATA: 'PROJECT_CREATE_POPUP__SET_DATA',
    SHOW_VALIDATION_ERRORS: 'PROJECT_CREATE_POPUP__SHOW_VALIDATION_ERRORS',
    HIDE_VALIDATION_ERRORS: 'PROJECT_CREATE_POPUP__HIDE_VALIDATION_ERRORS',
};

export const PROJECT_DELETE_POPUP = {
    OPEN: 'PROJECT_DELETE_POPUP__OPEN',
    CLOSE: 'PROJECT_DELETE_POPUP__CLOSE',
    SET_DATA: 'PROJECT_DELETE_POPUP__SET_DATA',
    RESET_DATA: 'PROJECT_DELETE_POPUP__RESET_DATA',
};

// page "My Documents"
export const MY_DOCUMENTS__STORE_DATA = 'MY_DOCUMENTS__STORE_DATA';
export const MY_DOCUMENTS__CLEAR_DATA = 'MY_DOCUMENTS__CLEAR_DATA';

// page "Project"
export const PROJECT_DATA_STORE = 'PROJECT_DATA_STORE';
export const PROJECT_DATA_CLEAR = 'PROJECT_DATA_CLEAR';
export const PROJECT_REMOVE_DOCUMENT = 'PROJECT_REMOVE_DOCUMENT';
export const PROJECT_DOCUMENT_UPDATE = 'PROJECT_DOCUMENT_UPDATE';

// page "Document Type"
export const DOCUMENT_TYPE_DATA_STORE = 'DOCUMENT_TYPE_DATA_STORE';
export const DOCUMENT_TYPE_DATA_CLEAR = 'DOCUMENT_TYPE_DATA_CLEAR';

// Page macDetails

export const MAC_DETAILS_FETCH_DATA_STORE = 'MAC_DETAILS_FETCH_DATA_STORE';
export const MAC_DETAILS_FETCH_DATA_STARTED = 'MAC_DETAILS_FETCH_DATA_STARTED';
export const MAC_DETAILS_FETCH_DATA_LOADED = 'MAC_DETAILS_FETCH_DATA_LOADED';
export const MAC_MENUS_FETCH_DATA_STARTED = 'MAC_MENUS_FETCH_DATA_STARTED';
export const MAC_MENUS_FETCH_DATA_LOADED = 'MAC_MENUS_FETCH_DATA_LOADED';
export const MAC_MENUS_FETCH_DATA_STORE = 'MAC_MENUS_FETCH_DATA_STORE';
export const MAC_MENUS_RESET_DATA = 'MAC_MENUS_RESET_DATA';
export const MAC_DOWNLOAD_LINK_STARTED = 'MAC_DOWNLOAD_LINK_STARTED';
export const MAC_DOWNLOAD_LINK_LOADED = 'MAC_DOWNLOAD_LINK_LOADED';

// Packages page

export const PACKAGES_SAVE_CURRENT = 'PACKAGES_SAVE_CURRENT';
export const PACKAGES_ADD_ITEM_TO_PACKAGE = 'PACKAGES_ADD_ITEM_TO_PACKAGE';
export const PACKAGES_REMOVE_ITEM_FROM_PACKAGE = 'PACKAGES_REMOVE_ITEM_FROM_PACKAGE';
export const PACKAGES_SAVE_PACKAGE_NAME = 'PACKAGES_SAVE_PACKAGE_NAME';
export const PACKAGES_STORE_ALL_PACKAGES = 'PACKAGES_STORE_ALL_PACKAGES';
export const PACKAGES_CHANGE_ACTIVE_PACKAGE = 'PACKAGES_CHANGE_ACTIVE_PACKAGE';
export const PACKAGES_REMOVE_PACKAGE = 'PACKAGES_REMOVE_PACKAGE';
export const PACKAGES_ADD_NEW_ACTIVE_PACKAGE = 'PACKAGES_ADD_NEW_ACTIVE_PACKAGE';
export const PACKAGES_REMOVE_PACKAGE_FROM_LIST = 'PACKAGES_REMOVE_PACKAGE_FROM_LIST';
export const PACKAGES_SAVE_EMAILS = 'PACKAGES_SAVE_EMAILS';
export const PACKAGES_CLOSE = 'PACKAGES_CLOSE';
export const PACKAGES_OPEN = 'PACKAGES_OPEN';
export const PACKAGES_SET_DELETING = 'PACKAGES_SET_DELETING';
export const PACKAGES_RESET_DELETING = 'PACKAGES_RESET_DELETING';

// Groups

export const GROUPS_FETCH_DATA_STARTED = 'GROUPS_FETCH_DATA_STARTED';
export const GROUPS_FETCH_DATA_LOADED = 'GROUPS_FETCH_DATA_LOADED';
export const GROUPS_FETCH_DATA_STORE = 'GROUPS_FETCH_DATA_STORE';
export const GROUPS_UPDATE_GROUPS_DATA = 'GROUPS_UPDATE_GROUPS_DATA';
export const GROUPS_OPEN = 'GROUPS_OPEN';
export const GROUPS_CLOSE = 'GROUPS_CLOSE';

// Notifications

export const NOTIFICATION__ADD = 'NOTIFICATION__ADD';
export const NOTIFICATION__REMOVE = 'NOTIFICATION__REMOVE';

// logout popup
export const HIDE_SNAP_ASSISTANT_REMINDER = 'HIDE_SNAP_ASSISTANT_REMINDER';
export const SHOW_SNAP_ASSISTANT_REMINDER = 'SHOW_SNAP_ASSISTANT_REMINDER';

